import React from "react"
import { RiTruckLine } from "react-icons/ri"
import { LiaShippingFastSolid } from "react-icons/lia"

const SitewideBanner = () => {
  const hideAfter = new Date("2025-12-09")
  const today = new Date()
  if (today > hideAfter) return null

  return (
    <div className="sitewide-banner">
      <LiaShippingFastSolid className="sitewide-banner__icon" />
      <span>
        Due to high demand, orders will ship after 9th December. Thanks for your
        patience!
      </span>
    </div>
  )
}

export default SitewideBanner
